import {Typography} from '@yandex-delivery/ui'
import clsx from 'clsx'
import React from 'react'

import type {LngLat} from '../../../map'
import {TariffsMapMarker} from '../TariffsMapMarker'
import styleClasses from './classes.module.css'

type Props = {
  coordinates: LngLat
  value: number
  onClick?: VoidFunction
}

export function Cluster({coordinates, value, onClick}: Props) {
  return (
    <TariffsMapMarker coordinates={coordinates}>
      <div className={clsx(styleClasses.cluster, onClick && styleClasses.clickable)} onClick={onClick}>
        <Typography color="textInvert" density="normal" level="body2" weight="regular">
          {value}
        </Typography>
      </div>
    </TariffsMapMarker>
  )
}
